import React from 'react';

const Solutions = () => {
  const styles = {
    container: { padding: '80px 20px' },
    header: { textAlign: 'center', marginBottom: '60px' },
    h1: { fontSize: '2.5rem', color: 'var(--text-dark)', marginBottom: '20px' },
    p: { color: 'var(--text-grey)', maxWidth: '700px', margin: '0 auto 40px', fontSize: '1.1rem', lineHeight: '1.6' },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px', marginTop: '40px' },
    card: { padding: '30px', border: '1px solid #eee', borderRadius: '12px', background: '#fff' },
    cardTitle: { fontSize: '1.5rem', marginBottom: '15px', color: 'var(--primary-dark)' }
  };

  const solutionsList = [
      { title: "Smart City Frameworks", desc: "Integrated IoT and AI platforms for urban management, traffic control, and utility monitoring." },
      { title: "Industrial Automation", desc: "Robotics and AI-driven process automation to enhance manufacturing efficiency and safety." },
      { title: "Predictive Maintenance", desc: "ML algorithms that predict equipment failures before they occur, saving downtime and costs." },
  ];

  return (
    <div className="container" style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.h1}>Innovative Solutions for a Connected World</h1>
        <p style={styles.p}>We don't just offer services; we build comprehensive solutions tailored to complex industry challenges.</p>
      </div>
      <div style={styles.grid}>
          {solutionsList.map((item, index) => (
              <div key={index} style={styles.card}>
                  <h3 style={styles.cardTitle}>{item.title}</h3>
                  <p style={{ color: 'var(--text-grey)', lineHeight: '1.6' }}>{item.desc}</p>
              </div>
          ))}
      </div>
    </div>
  );
};

export default Solutions;